// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__3LvHi","consentsList":"PatientConsents_consentsList__bQQ3u","consentsListEmpty":"PatientConsents_consentsListEmpty__3DikJ"};